module.exports = __webpack_public_path__ + "media/ambience-stagehall.feff99bd.mp3";